"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const events_1 = require("events");
const Requestor_1 = require("./Requestor");
const debug_1 = require("./util/debug");
class Processor extends events_1.EventEmitter {
    constructor(options) {
        super();
        this.logTag = (options === null || options === void 0 ? void 0 : options.logTag) || new debug_1.LogTag('--- post message to server ---');
        this.debugConsole = (options === null || options === void 0 ? void 0 : options.debugConsole) || debug_1.fakeConsole;
        this.stopHook = typeof (options === null || options === void 0 ? void 0 : options.onStop) === 'function' ? options === null || options === void 0 ? void 0 : options.onStop : () => { };
        this.unProcessChunk = '';
        this.isFirstResponse = true;
        this.isPaused = false;
    }
    handleChunk(chunk, isFinal) {
        if (this.isPaused) {
            return;
        }
        // 手动拆包
        const chunkArr = `${this.unProcessChunk}${chunk}`.split('\n\n');
        this.unProcessChunk = isFinal ? '' : (chunkArr.pop() || ''); // 最后一个包留着下次用，如果 done 了就不需要留着下次了
        for (let i = 0, l = chunkArr.length; i < l; i++) {
            const strToParse = chunkArr[i];
            if (!strToParse) {
                continue;
            }
            let chunkJson;
            try {
                chunkJson = JSON.parse(strToParse);
                if (typeof chunkJson.delta === 'string') {
                    this.logAndEmit(Requestor_1.EventType.Data, chunkJson);
                }
                else if (chunkJson.end) {
                    this.logAndEmit(Requestor_1.EventType.End, chunkJson);
                }
                else if (chunkJson.error) {
                    this.logAndEmit(Requestor_1.EventType.Error, chunkJson);
                }
                else {
                    // 兜底
                    const eventName = this.isFirstResponse ? Requestor_1.EventType.Init : Requestor_1.EventType.Data;
                    this.isFirstResponse = false;
                    this.logAndEmit(eventName, chunkJson);
                }
            }
            catch (e) {
                const err = new Error(`JSON.parse chunk失败 或者 'data'事件处理错误，chunk内容: ${strToParse}，错误信息: ${e.message}`);
                this.logAndEmit(Requestor_1.EventType.Error, err);
            }
        }
    }
    logAndEmit(type, dataOrError) {
        if (this.isPaused) {
            return;
        }
        this.debugConsole.log(this.logTag[type], dataOrError);
        this.emit(type, dataOrError);
    }
    async stop() {
        try {
            await this.stopHook.call(null);
        }
        catch (e) {
            /* do nothing */
        }
        finally {
            this.isPaused = true;
            this.logAndEmit(Requestor_1.EventType.Pause);
        }
    }
}
exports.default = Processor;
